var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48198 20.9999C6.4799 19.465 5.47063 17.9512 4.49253 16.4186C3.28908 14.531 2.06165 12.655 0.927722 10.7277C-1.63021 6.37304 1.38081 0.642366 6.50148 0.0559823C11.2649 -0.490686 15.1822 2.9622 14.9928 7.63925C14.9544 8.6041 14.7147 9.67173 14.2184 10.4917C12.1064 13.9797 9.86252 17.3928 7.66418 20.8294C7.63062 20.8808 7.57308 20.9158 7.48198 20.9976V20.9999ZM7.51075 4.06488C5.684 4.06955 4.21684 5.50164 4.21444 7.28181C4.21444 9.05264 5.68639 10.5081 7.50116 10.5221C9.33271 10.5385 10.8454 9.05498 10.831 7.26079C10.8166 5.48061 9.3423 4.06021 7.51075 4.06488Z",
    fill: "#B22134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRed);
export default __webpack_public_path__ + "static/media/Map-red.6f5172ae23e41c263f6d329a6b33f2d2.svg";
export { ForwardRef as ReactComponent };